import React, { useState } from 'react';
import { Mail, Bell, ScrollText } from 'lucide-react';
import EmailSettings from './EmailSettings';
import NotificationsSettings from './NotificationsSettings';
import AccessLogs from './AccessLogs';

const TABS = [
  { id: 'email', label: 'E-mail', icon: Mail, component: EmailSettings },
  { id: 'notifications', label: 'Notificações', icon: Bell, component: NotificationsSettings },
  { id: 'logs', label: 'Logs de Acesso', icon: ScrollText, component: AccessLogs },
];

const Settings = () => {
  const [activeTab, setActiveTab] = useState('email');

  const ActiveComponent = TABS.find((t) => t.id === activeTab)?.component || EmailSettings;

  return (
    <div className="space-y-6">
      {/* Nav Tabs */}
      <ul className="flex flex-wrap border-b border-gray-200">
        {TABS.map(({ id, label, icon: Icon }) => {
          const isActive = activeTab === id;
          return (
            <li key={id} className="-mb-px">
              <button
                type="button"
                onClick={() => setActiveTab(id)}
                className={`inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                  isActive
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <Icon size={16} strokeWidth={1.75} />
                <span className="hidden sm:block">{label}</span>
              </button>
            </li>
          );
        })}
      </ul>

      {/* Active tab content */}
      <ActiveComponent />
    </div>
  );
};

export default Settings;
